import { selectHelper } from '../../common/helpers'
import { messages } from '../../common/constants'


export const selectCustomerForSelect = (state) => {
    const { customers } = state.customer.customerList
    var customerValues = []

    if (!customers || customers.length == 0) return customerValues
    customerValues = selectHelper.getValuesForSelectCustomer(customers, 'id', 'name', 'lastname')
    return customerValues
}


// WEBPACK FOOTER //
// ./src/store/customer/selector.js